import { toast } from 'react-toastify';
import { AUTH_GET_INFO_URL, PUSH_NOTIFICATION_POST_TOKEN, STORE_SWITCH } from '../../config/api';
import http from '../../config/http';
import { removePageLoadingAction, setPageLoadingAction } from '../../layout/action';
import { getUserState, isDevelopment, setStoreForLocal, _route } from '../../utils';
import { getToken } from 'firebase/messaging';
import { WebPushCertificateKey } from '../../config';
import { firebaseMessaging } from '../../firebase';
import { getFCMTokenName } from '../../utils/featureCheck';

export const AUTH_SET_USER_INFO = 'AUTH_SET_USER_INFO';
export const AUTH_CLEAR_USER_INFO = 'AUTH_CLEAR_USER_INFO';
export const SET_REALM = 'SET_REALM';
export const SET_DOMAIN_FEATURES = 'SET_DOMAIN_FEATURES';

export const setDomainFeaturesAction = (payload) => ({
  type: SET_DOMAIN_FEATURES,
  payload,
});

export const authSetUserInfoAction = (payload) => ({
  type: AUTH_SET_USER_INFO,
  payload,
});

export const setPageRealm = (payload) => ({
  type: SET_REALM,
  payload,
});

export const setUserInfoToRedux = async (dispatch) => {
  const res = await (await http.get(AUTH_GET_INFO_URL)).data;
  dispatch(authSetUserInfoAction(res));
  getUserState.cache.clear();
  window.heap = window.heap ?? {};
  if (window.heap.identify) {
    window.heap.identify(res.user.userId);
    window.heap.addUserProperties({
      'Org Name': res?.org?.name,
      'Org Email': res?.org?.email,
      'User Name': res?.user?.name,
      'User Email': res?.user?.email,
      'Store Name': res?.store?.name,
      'Store Email': res?.store?.email,
      'Trail User': res?.store?.storeType,
    });
  }

  return res;
};

export const setFCMTokenToLocal = async () => {
  const { user } = getUserState();
  try {
    if (!user) return;
    const currentToken = await getToken(firebaseMessaging, {
      vapidKey: WebPushCertificateKey,
    });
    if (currentToken) {
      await http.post(PUSH_NOTIFICATION_POST_TOKEN.replace('{userId}', user?.userId), { token: currentToken });
      localStorage.setItem(getFCMTokenName(user?.userId), currentToken);
      return true;
    } else {
      toast.error('Service not available now!');
    }
  } catch (e) {
    console.error(e);
  }
};

export const switchStoreRedux = async (dispatch, storeId) => {
  dispatch(setPageLoadingAction());
  const resp = await http.post(STORE_SWITCH, { storeId });
  !isDevelopment() || setStoreForLocal(storeId);
  await setUserInfoToRedux(dispatch);
  dispatch(removePageLoadingAction());
  window.localStorage.removeItem('sg-date-global');
  return _route(resp.data.app ?? 'growz');
};
